import React, { FunctionComponent } from 'react'

import styles from './style.module.css'
import clsx from 'clsx'
import { ColorTypes, Span } from '@afterpaytouch/core'

interface Props {
  length?: number
  error?: boolean
  disabled?: boolean
  color?: ColorTypes
}

export const CardAsterisk: FunctionComponent<Props> = ({ length = 4, error = false, disabled = false, color }) => {
  if (length < 1) {
    return null
  }

  const classNames = clsx(styles.asterisk, disabled && styles.disabled, !disabled && (error ? styles.error : styles.standard))
  const asterisks = Array.from({ length }, (_, index) => <span className={classNames} key={`asterisk-${index}`} />)
  return <Span color={color}>{asterisks}</Span>
}
